import { useEffect } from 'react';

export const useKeyboardShortcuts = (
  onClose: () => void,
  isSubmitting: boolean,
  isLoading: boolean
): void => {
  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent): void => {
      if (event.key === 'Escape' && !isSubmitting && !isLoading) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscKey);
    return () => window.removeEventListener('keydown', handleEscKey);
  }, [onClose, isSubmitting, isLoading]);
};
